<div class="flex flex-col items-center gap-lg pt-2x-huge">
  <lib-discussion-icon iconClass="size-25" />

  <div class="flex flex-col items-center gap-sm">
    <div class="font-semibold text-xl text-neutral-900">
      {{ 'discussion_section_empty_state_title' | transloco }}
    </div>

    <div class="font-medium text-sm text-neutral-500">
      {{ 'discussion_section_empty_state_description' | transloco }}
    </div>
  </div>
</div>
